var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:environment-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1673 3.91602V2.41602L17.6673 2.24935C17.584 2.24935 17.084 2.16602 16.2507 2.16602C12.834 2.16602 10.334 3.16602 8.91732 4.91602C7.83398 4.24935 6.33398 3.83268 4.58398 3.83268C3.75065 3.83268 3.16732 3.91602 3.16732 3.91602L1.58398 4.16602L1.66732 5.58268C1.75065 8.08268 3.00065 12.8327 7.33398 12.8327H7.50065V15.666C4.33398 16.0827 1.66732 17.166 1.66732 17.166V18.8327H18.334V17.166C18.334 17.166 15.6673 16.0827 12.5007 15.666V12.9993C17.7507 12.916 19.1673 6.99935 19.1673 3.91602ZM10.0007 15.4993H9.16732V10.8327C9.16732 10.8327 9.00065 7.99935 6.66732 7.99935C6.66732 7.99935 7.91732 8.66602 8.25065 11.0827C7.91732 11.166 7.58398 11.166 7.33398 11.166C3.50065 11.166 3.33398 5.58268 3.33398 5.58268C3.33398 5.58268 3.83398 5.49935 4.58398 5.49935C6.16732 5.49935 8.75065 5.83268 9.50065 8.08268C9.91732 4.33268 14.1673 3.83268 16.2507 3.83268C17.0007 3.83268 17.5007 3.91602 17.5007 3.91602C17.5007 3.91602 17.5007 11.416 12.2507 11.416H11.6673C11.6673 9.74935 13.334 7.24935 13.334 7.24935C10.834 8.08268 10.834 11.3327 10.834 11.3327V15.4993H10.0007Z",
    fill: "#00A656"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantIcon);
export default __webpack_public_path__ + "static/media/plant_icon.3272644d2e62a8fa1c6f79da3374ed3b.svg";
export { ForwardRef as ReactComponent };